import { apiFetch, apiPost } from '@/utils/fetchWrapper';
import type {
  NominalMessagingConversation,
  PaginatedPendingMessagesResponse,
  PendingMessage,
  StaffMessageRecord,
} from '@/types/messaging';

export const messagingService = {
  async getPendingMessages(): Promise<PaginatedPendingMessagesResponse> {
    return apiFetch<PaginatedPendingMessagesResponse>('/messages/pending/');
  },

  async approveMessage(messageId: string): Promise<PendingMessage> {
    return apiPost<PendingMessage>(`/messages/${messageId}/approve/`, {});
  },

  async rejectMessage(messageId: string, reason?: string): Promise<PendingMessage> {
    return apiPost<PendingMessage>(`/messages/${messageId}/reject/`, {
      reason: reason ?? '',
    });
  },

  async listNominalConversations(
    nominalId: string
  ): Promise<NominalMessagingConversation[]> {
    return apiFetch<NominalMessagingConversation[]>(
      `/nominals/${nominalId}/messaging/conversations/`
    );
  },

  async listNominalConversationMessages(
    nominalId: string,
    conversationId: string
  ): Promise<StaffMessageRecord[]> {
    return apiFetch<StaffMessageRecord[]>(
      `/nominals/${nominalId}/messaging/conversations/${conversationId}/messages/`
    );
  },

  async hideMessage(messageId: string): Promise<StaffMessageRecord> {
    return apiPost<StaffMessageRecord>(`/messages/${messageId}/hide/`, {});
  },

  async unhideMessage(messageId: string): Promise<StaffMessageRecord> {
    return apiPost<StaffMessageRecord>(`/messages/${messageId}/unhide/`, {});
  },
};
